import { render, staticRenderFns } from "./companyPermissions.vue?vue&type=template&id=cb15c00a&scoped=true&"
import script from "./companyPermissions.vue?vue&type=script&lang=js&"
export * from "./companyPermissions.vue?vue&type=script&lang=js&"
import style0 from "./companyPermissions.vue?vue&type=style&index=0&id=cb15c00a&prod&lang=less&scoped=true&"
import style1 from "./companyPermissions.vue?vue&type=style&index=1&id=cb15c00a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb15c00a",
  null
  
)

export default component.exports